// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"096c7828","635":"2daf471b"}[chunkId] + ".chunk.js";
};